import PatientOverviewPAGoalSettingWeeklySportsGoal from 'dashboard/templates/views/Patient/PA/PatientOverviewPAGoalSettingWeeklySportsGoal';

export default {
  path: 'weekly-sports-goal',
  name: 'PatientRecordPAGoalSettingWeeklySportsGoal',
  component: PatientOverviewPAGoalSettingWeeklySportsGoal,
  meta: {
    // title: 'Patient Record - Physical Activity - Goal Setting - Weekly Sports Goal',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')} - ${t('pa.weeklySportsGoal')}`,
    // title: 'Start Moving - Goal Setting',
    title: t => `${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
